import { Appointment, Professional, ServiceFunction } from '@/types/appointment';

export const professionals: Professional[] = [
  { id: '1', name: 'Dr. Ana Silva', role: 'Clínico Geral' },
  { id: '2', name: 'Dr. Carlos Santos', role: 'Cardiologista' },
  { id: '3', name: 'Dra. Maria Oliveira', role: 'Dermatologista' },
  { id: '4', name: 'Dr. Pedro Costa', role: 'Ortopedista' },
];

export const serviceFunctions: ServiceFunction[] = [
  { id: '1', name: 'Consulta', duration: 30, color: '#3B82F6' },
  { id: '2', name: 'Retorno', duration: 15, color: '#10B981' },
  { id: '3', name: 'Exame', duration: 45, color: '#F59E0B' },
  { id: '4', name: 'Procedimento', duration: 60, color: '#8B5CF6' },
];

const today = new Date();
const getDate = (daysOffset: number, hour: number, minute: number = 0) => {
  const date = new Date(today);
  date.setDate(date.getDate() + daysOffset);
  date.setHours(hour, minute, 0, 0);
  return date;
};

export const appointments: Appointment[] = [
  {
    id: '1',
    clientName: 'João Pereira',
    clientEmail: 'joao@email.com',
    clientPhone: '(11) 99999-1111',
    professional: 'Dr. Ana Silva',
    professionalId: '1',
    function: 'Consulta',
    functionId: '1',
    date: getDate(0, 9),
    startTime: '09:00',
    endTime: '09:30',
    status: 'confirmed',
    notes: 'Primeira consulta',
  },
  {
    id: '2',
    clientName: 'Maria Santos',
    clientEmail: 'maria@email.com',
    clientPhone: '(11) 99999-2222',
    professional: 'Dr. Carlos Santos',
    professionalId: '2',
    function: 'Retorno',
    functionId: '2',
    date: getDate(0, 10),
    startTime: '10:00',
    endTime: '10:15',
    status: 'pending',
  },
  {
    id: '3',
    clientName: 'Pedro Almeida',
    clientEmail: 'pedro@email.com',
    clientPhone: '(11) 99999-3333',
    professional: 'Dra. Maria Oliveira',
    professionalId: '3',
    function: 'Exame',
    functionId: '3',
    date: getDate(0, 14),
    startTime: '14:00',
    endTime: '16:00',
    status: 'confirmed',
  },
  {
    id: '4',
    clientName: 'Ana Costa',
    clientEmail: 'ana@email.com',
    clientPhone: '(11) 99999-4444',
    professional: 'Dr. Pedro Costa',
    professionalId: '4',
    function: 'Procedimento',
    functionId: '4',
    date: getDate(1, 11),
    startTime: '11:00',
    endTime: '12:00',
    status: 'cancelled',
  },
  {
    id: '5',
    clientName: 'Lucas Ferreira',
    clientEmail: 'lucas@email.com',
    clientPhone: '(11) 99999-5555',
    professional: 'Dr. Ana Silva',
    professionalId: '1',
    function: 'Consulta',
    functionId: '1',
    date: getDate(1, 15),
    startTime: '15:00',
    endTime: '15:30',
    status: 'confirmed',
  },
  {
    id: '6',
    clientName: 'Juliana Lima',
    clientEmail: 'juliana@email.com',
    clientPhone: '(11) 99999-6666',
    professional: 'Dr. Carlos Santos',
    professionalId: '2',
    function: 'Consulta',
    functionId: '1',
    date: getDate(2, 9),
    startTime: '09:00',
    endTime: '09:30',
    status: 'pending',
  },
  {
    id: '7',
    clientName: 'Roberto Souza',
    clientEmail: 'roberto@email.com',
    clientPhone: '(11) 99999-7777',
    professional: 'Dra. Maria Oliveira',
    professionalId: '3',
    function: 'Retorno',
    functionId: '2',
    date: getDate(3, 16),
    startTime: '16:00',
    endTime: '16:15',
    status: 'confirmed',
  },
  {
    id: '8',
    clientName: 'Fernanda Rocha',
    clientEmail: 'fernanda@email.com',
    clientPhone: '(11) 99999-8888',
    professional: 'Dr. Pedro Costa',
    professionalId: '4',
    function: 'Exame',
    functionId: '3',
    date: getDate(-1, 10),
    startTime: '10:00',
    endTime: '10:45',
    status: 'confirmed',
  },
  {
    id: '9',
    clientName: 'Gabriel Martins',
    clientEmail: 'gabriel@email.com',
    clientPhone: '(11) 99999-9999',
    professional: 'Dr. Ana Silva',
    professionalId: '1',
    function: 'Procedimento',
    functionId: '4',
    date: getDate(5, 14),
    startTime: '14:00',
    endTime: '15:00',
    status: 'pending',
  },
  {
    id: '10',
    clientName: 'Carla Dias',
    clientEmail: 'carla@email.com',
    clientPhone: '(11) 99999-0000',
    professional: 'Dr. Carlos Santos',
    professionalId: '2',
    function: 'Consulta',
    functionId: '1',
    date: getDate(7, 11),
    startTime: '11:00',
    endTime: '11:30',
    status: 'confirmed',
  },
];
